import { trackEvent } from "../../utils/FunctionsGlobals";

const getCookie = (name: string): string =>
    document.cookie
        .split('; ')
        .find((row) => row.startsWith(name + '='))
        ?.split('=')[1] || '';

const normalizeName = (value: unknown): string =>
    typeof value === 'string' ? value.trim().toLowerCase() : '';

const normalizeEmail = (value: unknown): string =>
    typeof value === 'string' ? value.trim().toLowerCase() : '';

const normalizePhone = (value: unknown): string =>
    typeof value === 'string' ? value.replace(/\D/g, '') : '';

const sha256Hex = async (value: string): Promise<string> => {
    if (!value) return '';

    const subtle = typeof window !== 'undefined' ? window.crypto?.subtle : undefined;
    if (!subtle) return '';

    const data = new TextEncoder().encode(value);
    const digest = await subtle.digest('SHA-256', data);

    return Array.from(new Uint8Array(digest))
        .map((byte) => byte.toString(16).padStart(2, '0'))
        .join('');
};

const extractPixelId = (snippet: string): string => {
    if (!snippet) return '';
    const match = snippet.match(/init'\s*,\s*'([^']+)'/i);
    return match?.[1] || '';
};

export const trackLead = (site: any, property: any) => {
    if (site?.tag_google_head || site?.google_analytics_head) {
        trackEvent("whatsapp_click", { source: "whatsapp_click" });
    }

    const shouldTrackLead = Boolean(
        property?.id && (
            (site?.fb_token_pixel && site?.fb_id_pixel) ||
            site?.pixel_facebook_head
        )
    );

    if (!shouldTrackLead || typeof window === 'undefined') {
        return;
    }

    void (async () => {
        const user = JSON.parse(localStorage.getItem("user") || "{}");
        const normalizedName = normalizeName(user?.name);
        const normalizedEmail = normalizeEmail(user?.email);
        const normalizedPhone = normalizePhone(user?.telephone);
        const normalizedId = user?.id_client ? String(user.id_client) : '';

        const [hashNome, hashEmail, hashTelefone, hashId] = await Promise.all([
            sha256Hex(normalizedName),
            sha256Hex(normalizedEmail),
            sha256Hex(normalizedPhone),
            sha256Hex(normalizedId),
        ]);

        if (site?.fb_token_pixel && site?.fb_id_pixel) {
            const eventData = [
                {
                    event_name: 'Lead',
                    event_time: Math.floor(Date.now() / 1000),
                    action_source: 'website',
                    event_source_url: 'https://' + site?.site,
                    user_data: {
                        fn: hashNome ? [hashNome] : [],
                        em: hashEmail ? [hashEmail] : [],
                        ph: hashTelefone ? [hashTelefone] : [],
                        fbc: getCookie('_fbc') || undefined,
                        fbp: getCookie('_fbp') || undefined,
                        external_id: hashId ? [hashId] : [],
                    },
                    custom_data: {
                        content_name: property?.titulo || "Imóvel",
                        content_category: property?.categoria?.nome || "Imóveis",
                        content_ids: [property?.id || "N/A"],
                        content_type: "home_listing",
                        currency: "BRL",
                        value: property?.preco_venda || 0,
                    },
                }
            ];

            try {
                await fetch(
                    `https://graph.facebook.com/v12.0/${site.fb_id_pixel}/events?access_token=${site.fb_token_pixel}`,
                    {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ data: eventData }),
                        keepalive: true,
                    }
                );
            } catch {
                // Silencia falhas de rede de terceiros para não impactar a experiência.
            }
        }

        if (site?.pixel_facebook_head) {
            const pixelFacebookId = extractPixelId(site.pixel_facebook_head);
            if (!pixelFacebookId) return;

            try {
                const ReactPixel = (await import('react-facebook-pixel')).default;
                ReactPixel.init(pixelFacebookId as any);
                ReactPixel.track("Lead", {
                    content_name: property?.titulo || "Imóvel",
                    content_category: property?.categoria?.nome || "Imóveis",
                    content_ids: [property?.id || "N/A"],
                    content_type: "home_listing",
                    currency: "BRL",
                    value: property?.preco_venda || 0,
                    action_source: "website",
                    event_source_url: window.location.href,
                    user_data: {
                        fn: hashNome ? [hashNome] : [],
                        ph: hashTelefone ? [hashTelefone] : [],
                        em: hashEmail ? [hashEmail] : [],
                        external_id: hashId ? [hashId] : [],
                    },
                });
            } catch {
                // Silencia falhas de SDK de terceiros.
            }
        }
    })();
};
